module.exports = __webpack_public_path__ + "img/matthew-pfp.579065aa.jpg";